import React from 'react';
import {Editor} from 'primereact/editor';
import ReactQuill from 'react-quill';


interface Props {
  style?: any;
  value: any;
  onChange: any;
  readonly?: any;
}

export default function EditorSigilo({style, value, onChange, readonly}: Props) {

  const myColors = [
    '#ffffff',
    '#000000',
  ];
  const modules = {
    toolbar: [      
      [{background: myColors}]
    ]
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'link',
    'color',
    'image',
    'background',
    'align'
  ];


  return (
    <>
      <div>
        <ReactQuill
          theme="snow"
          modules={modules}
          formats={formats}
          readOnly={readonly}
          value={value}
          style={style}
          onChange={onChange}
        />
      </div>
    </>
  );

}
